/**
 * Node modules
 */
import Radio from 'antd/lib/radio';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Functional components
 */
const VendorAntRadioButton = (props) => {
  const {
    isDisabled,
    ...rest
  } = props;
  return (
    <Radio.Button
      disabled={isDisabled}
      {...rest}
    />
  );
};
VendorAntRadioButton.defaultProps = { isDisabled: false };
VendorAntRadioButton.displayName = 'VendorAntRadioButton';
VendorAntRadioButton.propTypes = { isDisabled: PropTypes.bool };
export default VendorAntRadioButton;
